<template>
  <IconFont class="icon-shop" name="icon-a-dianpuguanlisbeifen2x" />
</template>

<script>
  export default {
    name: 'icon-shop',
  };
</script>

<style>
  .icon-shop {
    font-size: 16px;
  }
</style>
